/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Automix_Fixed_Gain_SuffixInputs */



/**
* | output |
* | --- |
* | "(Fixed Gain)" |
*
* @param {Audio_Description_Export_Automix_Fixed_Gain_SuffixInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_automix_fixed_gain_suffix = /** @type {((inputs?: Audio_Description_Export_Automix_Fixed_Gain_SuffixInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Automix_Fixed_Gain_SuffixInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("(Gain fixe)")
	if (locale === "de") return /** @type {LocalizedString} */ ("(Fester Gewinn)")
	if (locale === "it") return /** @type {LocalizedString} */ ("(Guadagno fisso)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("(Фиксированный коэффициент усиления)")
	if (locale === "es") return /** @type {LocalizedString} */ ("(Ganancia fija)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("（固定收益）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("（固定ゲイン）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("(निश्चित लाभ)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("(Ganho Fixo)")
	return /** @type {LocalizedString} */ ("(Fixed Gain)")
});